export const Banks = {
  "State Bank of India (SBI)": "State Bank of India (SBI)",
  "Punjab National Bank (PNB)": "Punjab National Bank (PNB)",
  "Bank of Baroda (BoB)": "Bank of Baroda (BoB)",
  "Canara Bank": "Canara Bank",
  "Union Bank of India": "Union Bank of India",
  "Bank of India (BoI)": "Bank of India (BoI)",
  "Indian Bank": "Indian Bank",
  "Central Bank of India": "Central Bank of India",
  "Indian Overseas Bank (IOB)": "Indian Overseas Bank (IOB)",
  "UCO Bank": "UCO Bank",
  "Bank of Maharashtra": "Bank of Maharashtra",
  "Punjab & Sind Bank": "Punjab & Sind Bank",
  "HDFC Bank": "HDFC Bank",
  "ICICI Bank": "ICICI Bank",
  "Axis Bank": "Axis Bank",
  "Kotak Mahindra Bank": "Kotak Mahindra Bank",
  "IndusInd Bank": "IndusInd Bank",
  "Yes Bank": "Yes Bank",
  "Federal Bank": "Federal Bank",
  "IDFC First Bank": "IDFC First Bank",
  "RBL Bank (Ratnakar Bank)": "RBL Bank (Ratnakar Bank)",
  "South Indian Bank": "South Indian Bank",
  "Bandhan Bank": "Bandhan Bank",
  "City Union Bank": "City Union Bank",
  "Karur Vysya Bank": "Karur Vysya Bank",
  "Tamilnad Mercantile Bank": "Tamilnad Mercantile Bank",
  "Andhra Pradesh Grameena Vikas Bank": "Andhra Pradesh Grameena Vikas Bank",
  "Baroda Gujarat Gramin Bank": "Baroda Gujarat Gramin Bank",
  "Kerala Gramin Bank": "Kerala Gramin Bank",
  "Madhyanchal Gramin Bank": "Madhyanchal Gramin Bank",
  "Prathama UP Gramin Bank": "Prathama UP Gramin Bank",
  "Sarva Haryana Gramin Bank": "Sarva Haryana Gramin Bank",
  Citibank: "Citibank",
  "HSBC (Hongkong and Shanghai Banking Corporation)":
    "HSBC (Hongkong and Shanghai Banking Corporation)",
  "Standard Chartered Bank": "Standard Chartered Bank",
  "Deutsche Bank": "Deutsche Bank",
  "Barclays Bank": "Barclays Bank",
  "DBS Bank": "DBS Bank",
  "BNP Paribas": "BNP Paribas",
  "Bank of America": "Bank of America",
  "JPMorgan Chase": "JPMorgan Chase",
  "The Royal Bank of Scotland (RBS)": "The Royal Bank of Scotland (RBS)",
};
